import styles from './BrowserHint.module.css'

type BrowserHintProps = {
  onClose: () => void
}

function BrowserHint(props: BrowserHintProps) {
  const { onClose } = props
  const text = '請點擊右上角\n選擇“瀏覽器中打開”'

  return (
    <div className={styles.root} onClick={onClose}>
      <div className={styles.bubble}>{text}</div>
    </div>
  )
}

export default BrowserHint
